import React from "react";
import ReactDOM from "react-dom";
import { FiX } from "react-icons/fi";

export default function MediaPreview({ open, file, onClose }) {
  if (!open || !file) return null;

  // file is now expected to be a URL string
  const url = file;

  // Simple type detection from URL extension
  const isImage = url.match(/\.(jpg|jpeg|png|gif|webp)$/i);
  const isVideo = url.match(/\.(mp4|mov|webm|ogg)$/i);

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-2xl max-w-[95vw] max-h-[95vh] relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-900"
        >
          <FiX className="w-6 h-6" />
        </button>

        <h4 className="font-semibold mb-4">Preview</h4>

        {isImage && <img src={url} className="max-h-[80vh] rounded-lg" alt="preview" />}
        {isVideo && <video src={url} controls className="max-h-[80vh] max-w-[80vw] rounded-lg" />}
        {!isImage && !isVideo && <p className="text-center text-gray-500">Unsupported media type</p>}
      </div>
    </div>,
    document.body
  );
}
